import { LOCALE, TranslationMap } from './i18n';
import isEmptyString from './is-empty-string';
import removeAccents from './remove-accents';
import { slugify } from '@crazygames/utils/slugify';

export function slugifyTag(text: string) {
  const withoutAccents = removeAccents(text);
  const withoutUrlChars = withoutAccents.replace(/[&=,]/g, ' ');
  return slugify(withoutUrlChars);
}

export function slugifyTranslationMap(map: TranslationMap): TranslationMap {
  const result: Partial<TranslationMap> = {};
  for (const [locale, slug] of Object.entries(map)) {
    result[locale as LOCALE] = isEmptyString(slug) ? undefined : slugify(slug);
  }
  return result as TranslationMap;
}

export const MAX_SLUG_LENGTH = 35;
export function isValidSlug(slug: string) {
  return slug && slug.length > 0 && slug.length <= MAX_SLUG_LENGTH;
}

export default slugify;
